import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { IReducer } from '../../../../../../redux/configureStore';
import {
  DownloadReport,
  Loading,
} from '../../../../../../shared/components/buttons/SearchButton';
import Wrapper from '../../../../../../shared/components/Wrapper';
import { reportClosed } from '../AccountingFilter/functions';
import UnifiedReportPdf from '../ClosedReport/components/ExportPdf/components/UnifiedReportPdf';
import SetMonthEnd from './FilterModal/components/SetMonthEnd';
import SetMonthInitial from './FilterModal/components/SetMonthInitial';
import { ClosedReportCsvData } from './FilterModal/data';

const validationRedenring = (e, l) => {
  if (e === '' || l === '') {
    return (
      <DownloadReport
        justifyContent="center"
        backgroundColor="#a4a4a4"
        width="136px"
      />
    );
  }
  return <Loading justifyContent="center" width="136px" />;
};

function ReportMacroSmartExcel({ show, onHide }: any) {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [fare, setFareOption] = useState('fiducia');
  const closedDataContext = useSelector(
    (reducer: IReducer) => reducer.closedData
  );

  function setFare(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    setFareOption(value);
  }

  const database: any = ClosedReportCsvData();

  const header = [
    { label: 'INDEX', key: 'index' },
    { label: 'DESCRIÇÃO', key: 'description' },
    { label: 'CÓDIGO', key: 'code' },
    { label: 'VALOR', key: 'value' },
  ];

  useEffect(() => {
    if (initial !== '' && end !== '') {
      reportClosed(initial, end, fare, dispatch);
    }
  }, [initial, end, fare, dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      style={{
        borderRadius: '10px 10px 0px 0px',
        display: 'block',
        maxWidth: '550px',
        margin: 'auto',
        left: '50%',
        transform: 'translate(-50%,0%)',
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        style={{
          background: '#125C5B',
          color: '#fff',
          fontStyle: 'normal',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <Modal.Title
          style={{
            fontSize: '22px',
            lineHeight: '26px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
          id="contained-modal-title-vcenter">
          Download do relatório de fechamento em Excel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Default isActive flexDirection="row">
          <SetMonthInitial setDate={setInitial} date={initial} />
          <SetMonthEnd setDate={setEnd} date={end} />
          <Wrapper.Default flexDirection="column" isActive>
            <Wrapper.Label>Conta:</Wrapper.Label>
            <Form.Control
              as="select"
              style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
              value={fare}
              onChange={(event) => setFare(event)}>
              <option key={0} value="fiducia">
                {1} - Fidúcia
              </option>
              <option key={1} value="terceiros">
                {2} - Terceiros
              </option>
            </Form.Control>
          </Wrapper.Default>
        </Wrapper.Default>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          border: 'none',
        }}>
        <Wrapper.Button onClick={onHide}>Fechar</Wrapper.Button>
        {!closedDataContext.isLoading && initial !== '' && end !== '' ? (
          <CSVLink
            data={database}
            headers={header}
            filename="Relatório de fechamento.csv">
            <DownloadReport justifyContent="center" width="136px" />
          </CSVLink>
        ) : (
          validationRedenring(initial, end)
        )}
      </Modal.Footer>
    </Modal>
  );
}

export function ReportMacroSmartPdf({ show, onHide }: any) {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [fare, setFareOption] = useState('fiducia');
  const componentRef: any = React.useRef();

  const closedDataContext = useSelector(
    (reducer: IReducer) => reducer.closedData
  );

  useEffect(() => {
    if (initial !== '' && end !== '') {
      reportClosed(initial, end, fare, dispatch);
    }
  }, [initial, end, fare, dispatch]);

  function setFare(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    setFareOption(value);
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      style={{
        borderRadius: '10px 10px 0px 0px',
        display: 'block',
        maxWidth: '550px',
        margin: 'auto',
        left: '50%',
        transform: 'translate(-50%,0%)',
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <div style={{ display: 'none' }}>
        <UnifiedReportPdf data={closedDataContext} ref={componentRef} />
      </div>
      <Modal.Header
        style={{
          background: '#125C5B',
          color: '#fff',
          fontStyle: 'normal',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <Modal.Title
          style={{
            fontSize: '22px',
            lineHeight: '26px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
          id="contained-modal-title-vcenter">
          Download do relatório de fechamento em Pdf
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Default isActive flexDirection="row">
          <SetMonthInitial setDate={setInitial} date={initial} />
          <SetMonthEnd setDate={setEnd} date={end} />
          <Wrapper.Default flexDirection="column" isActive>
            <Wrapper.Label>Conta:</Wrapper.Label>
            <Form.Control
              as="select"
              style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
              value={fare}
              onChange={(event) => setFare(event)}>
              <option key={0} value="fiducia">
                {1} - Fidúcia
              </option>
              <option key={1} value="terceiros">
                {2} - Terceiros
              </option>
            </Form.Control>
          </Wrapper.Default>
        </Wrapper.Default>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          border: 'none',
        }}>
        <Wrapper.Button onClick={onHide}>Fechar</Wrapper.Button>

        {!closedDataContext.isLoading ? (
          <ReactToPrint
            trigger={() => {
              return <DownloadReport justifyContent="center" width="136px" />;
            }}
            content={() => componentRef.current}
          />
        ) : (
          validationRedenring(initial, end)
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ReportMacroSmartExcel;
